import React, { useContext, useEffect, useState } from 'react'
import { WalletButtonGrey, WalletButtonPink } from '.'
import WalletButtonRed from './WalletButtonRed'
import './index.sass'
import { DarkModeContext } from '../../global/Theme'

export default function CreditCard({cardnumber, cardtype, cardexp, isDefault, isVerified}) {
    const {isDark} = useContext(DarkModeContext);

    return (
        <div className={`creditCardWrapper ${isDark ? 'feed-dark' : 'feed-light'}`} >
            <div className='creditCardImage'>
                <div className='creditCardIcons'>
                    <img src={require(`../../assets/icons/${cardtype}logo.svg`)} alt='cardtype' />
                    <img src={require('../../assets/icons/trash.svg')} alt='cardtype' />
                </div>
                <p className='cardNumber'>{`... ${cardnumber}`}</p>
                <p className='cardExp'>{`Exp ${cardexp}`}</p>
            </div>
            <div className='creditCardInfo'>
                {(isVerified) ? <WalletButtonGrey text='verified' /> : <WalletButtonPink text='verify' />}
                {(isDefault) ? <WalletButtonGrey text='default'/> : <WalletButtonRed text=' Make Default'/>}
            </div>
        </div>
    )
}
